/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import Icon from '@ant-design/icons';

const HungarianFlagIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" id="flag-icons-hu" viewBox="0 0 640 480">
    <path fill="#fff" d="M640 480H0V0h640z"/>
    <path fill="#388d00" d="M640 480H0V320h640z"/>
    <path fill="#d43516" d="M640 160.1H0V.1h640z"/>
  </svg>
);

export const HungarianFlagIcon = (props) => (
  <Icon component={HungarianFlagIconSvg} {...props} />
);
